import { ListManager, Paginator } from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import clinics from '@/services/api/clinics'
import React from 'react'
import { useHistory, useParams } from 'react-router-dom'

function CastrationsApproved({ title }) {
  usePageTitle({ title })

  const query = useQuery()
  const { id } = useParams()
  const history = useHistory()
  const { data, error, loading } = useAxiosRequest(
    clinics.castrationsApprovedByDay,
    id,
    query,
  )

  return (
    <div className="modal active" id="modal-id">
      <a
        type="button"
        className="modal-overlay"
        aria-label="Close"
        onClick={() => history.goBack()}
      />
      <div className="modal-container">
        <div className="modal-header">
          <a
            type="button"
            className="btn btn-clear float-right"
            onClick={() => history.goBack()}
          />
          <div className="modal-title h5">Castrações aprovadas por dia</div>
          <cite>
            Lista completa da quantidade de castrações aprovadas da clínica,
            organizadas por data
            <small> (Castrações canceladas não são consideradas na contagem)</small>
          </cite>
        </div>
        <div className="modal-body">
          <div className="content">
            <ListManager
              loading={loading}
              count={data?.count || 0}
              error={error}
            >
              <div className="divider" />
              <table className="table table-hover table-striped text-small">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th className="text-right" width="200px">
                      Quantidade
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Boolean(data?.rows)
                    && data?.rows.map((row) => (
                      <tr key={row?.dayString}>
                        <td>{row?.dayString}</td>
                        <td className="text-right">{row?.approved}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {Boolean(data) && (
                <div className="my-2">
                  <Paginator paginatedList={data} />
                </div>
              )}
            </ListManager>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CastrationsApproved
